export default __webpack_public_path__ + "static/media/youtube-default-icon.b7f007b8.svg";